export default "__VITE_ASSET__3ee41161__"